// extracted by mini-css-extract-plugin
module.exports = {"ItemsGrid":"Merchandise_ItemsGrid__2C_0a","OrdersTable":"Merchandise_OrdersTable__389mh","OrdersHeader":"Merchandise_OrdersHeader__1WkNu","Controls":"Merchandise_Controls__1JdSW"};